import * as React from "react";

export default class FormItemlist extends React.Component {
    state = {
        availableItems: [],
        selectedItems: []
    }

    constructor(props) {
        super(props);

    }

    addSelectedItem(id, availableItem) {
        let selectedItems = this.state.selectedItems;

        for (let i = 0; i < selectedItems.length; i++) {
            if(selectedItems[i].id === id) {
                selectedItems[i].amount++;
                return this.setState(selectedItems);
            }
        }

        selectedItems.push({
            id: id,
            name: availableItem.name,
            price: availableItem.price,
            amount: 1
        });

        this.setState(selectedItems);
    }

    getNetSum() {
        let sum = 0;

        for (let i = 0; i < this.state.selectedItems.length; i++) {
            sum += this.state.selectedItems[i].amount * this.state.selectedItems[i].price;
        }

        return sum;
    }

    getShippingSum() {
        if(this.getNetSum() <= 50) {
            return 3.9;
        }

        return 0;
    }

    getVat() {
        return (this.getNetSum() + this.getShippingSum()) * this.props.formData.vatPercent / 100;
    }

    getSums() {
        return {
            net: this.getNetSum(),
            shipping: this.getShippingSum(),
            vat: this.getVat(),
            total: this.getNetSum() + this.getShippingSum() + this.getVat()
        }
    }

    getLocalizedAmount(number) {
        return number.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + this.props.formData.currencySymbol;
    }

    getTextResult() {
        let articleSummary = "";

        for (let i = 0; i < this.state.selectedItems.length; i++) {
            articleSummary = articleSummary + this.state.selectedItems[i].amount + " " + this.state.selectedItems[i].name + "\n";
        }

        let sums = this.getSums();

        return `
                Artikel
                ==========
                ${articleSummary}
                
                ==========
                
                Netto:${this.getLocalizedAmount(sums.net)}
                Versand:${this.getLocalizedAmount(sums.shipping)}
                MwSt:${this.getLocalizedAmount(sums.vat)}
                Summe:${this.getLocalizedAmount(sums.total)}`;
    }

    componentDidUpdate() {
        if(typeof this.props.onUpdate === 'function') {
            this.props.onUpdate(this.getTextResult());
        }
    }

    updateItemAmount(index, amount) {
        let selectedItems = this.state.selectedItems;

        if (amount === '' || isNaN(parseInt(amount)) || amount < 0) {
            amount = 0
        } else {
            amount = parseInt(amount);
        }

        selectedItems[index].amount = amount;

        this.setState(selectedItems);
    }

    removeItem(index) {
        let selectedItems = this.state.selectedItems;
        selectedItems.splice(index, 1);
        this.setState(selectedItems);
    }

    render() {
        let sums = this.getSums();

        return (
            <div>
                <h3>Zubehörartikel</h3>
                <ul className="itemlist__availableItems">
                    {this.props.formData.availableItems.map((item, i) => (
                        <li key={i}>
                            <div className="itemInfo">
                                <span className="article">{item.name}</span>
                                <span className="price">{this.getLocalizedAmount(item.price)}</span>
                                <small className="description">{item.description}</small>
                            </div>
                            <button type="button" className="button button--green" onClick={() => this.addSelectedItem(i, item)}>Hinzufügen</button>
                        </li>
                    ))}
                </ul>
                <div className="itemlist__orderSummary">
                    <h3>Ihre Bestellung</h3>
                    <table>
                        <thead>
                        <tr>
                            <th className={"amount"}>Pakete</th>
                            <th className={"name"}>Artikel</th>
                            <th className={"price"}>Paketpreis</th>
                            <th className={"sum"}>Gesamt</th>
                            <th className={"action"}>&nbsp;</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.state.selectedItems.map((item, i) => (
                            <tr key={i}>
                                <td>
                                    <div className="textInput">
                                        <input type={"number"} value={item.amount} onChange={(event) => { this.updateItemAmount(i, event.target.value)}} aria-label={"Pakete"} />
                                    </div>
                                </td>
                                <td>{item.name}</td>
                                <td>{this.getLocalizedAmount(item.price)}</td>
                                <td>{this.getLocalizedAmount(item.price * item.amount)}</td>
                                <td><button type="button" className="button button--white" onClick={() => this.removeItem(i)} aria-label={"Löschen"} title={"Löschen"}>X</button></td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    <h4>Summe</h4>
                    <dl>
                        <dt>Netto:</dt>
                        <dd>{this.getLocalizedAmount(sums.net)}</dd>
                        <dt>Versandkosten:</dt>
                        <dd>{this.getLocalizedAmount(sums.shipping)}</dd>
                        <dt>zzgl. % MwSt:</dt>
                        <dd>{this.getLocalizedAmount(sums.vat)}</dd>
                        <dt>Gesamtsumme:</dt>
                        <dd>{this.getLocalizedAmount(sums.total)}</dd>
                    </dl>
                </div>
            </div>
        )
    }
}
